/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { widgetsList } from "../funcs/widgetsList.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ListWidgetsResult } from "../models/components/listwidgetsresult.js";
import {
  ListWidgetsRequest,
  ListWidgetsSecurity,
} from "../models/operations/listwidgets.js";
import { unwrapAsync } from "../types/fp.js";
export type WidgetsQueryData = ListWidgetsResult;

export function prefetchWidgets(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListWidgetsRequest | undefined,
  security?: ListWidgetsSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildWidgetsQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildWidgetsQuery(
  client$: GramCore,
  request?: ListWidgetsRequest | undefined,
  security?: ListWidgetsSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (context: QueryFunctionContext) => Promise<WidgetsQueryData>;
} {
  return {
    queryKey: queryKeyWidgets({
      gramSession: request?.gramSession,
      gramProject: request?.gramProject,
    }),
    queryFn: async function widgetsQueryFn(ctx): Promise<WidgetsQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(widgetsList(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyWidgets(
  parameters: {
    gramSession?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "widgets", "list", parameters];
}
